import * as marietta from '../../..';
import { ChangeItem } from '../../../view3d/webcad/ChangeItem';
import * as webcad from '../../../webcad';
import { Dialog } from '../../../core/view';
/**
 * 3Dーアイテムの３Dイメージ変更
 * 対象：家具、設備、エクステリア
 */
export default class ChangeWallTextureDialog extends Dialog {
  public index: number = 0;

  public target: any = -1;

  public alternatives: any[] = [];

  public dir: string = '';

  /**
   * コンストラクタ
   */
  // eslint-disable-next-line no-useless-constructor
  constructor(draggable: boolean) {
    super(draggable);
  }

  buildContent() {
    console.log(this.index);

    // ダイアログのコンテンツ生成
    const id = 'changeWallTextureDialog';

    let title = '';
    // タイトル
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp': title = 'テクスチャ変更'; break;
      default: title = 'Change Texture'; break;
    }

    let contents = '<div class="changeWallTextureMenu">';
    contents += '<div class="changeWallTextureMenuRow">';
    contents += '<ul>';
    // 家具変更ダイアログの処理を参考に残す
    contents += '<li class="btnChangeWallTexture" data-itemid="0">';
    contents += `<button id="changeWallTexture${String(0)}">`;
    contents += '<div class="imgBox">';
    contents += `<img src="${this.dir}${this.target.userData.attribute.thumbnail}" width="96" height="96"/>`;
    contents += '</div>';
    contents += '<p><span class="jp">ホワイトモデル</span><span class="en">White Model</span></p>';
    contents += '</li>';
    if (this.alternatives !== undefined) {
      for (let i = 1; i <= this.alternatives.length; i += 1) {
        const alt = this.alternatives[i - 1];
        const imgPath = this.dir + alt.thumbnail;
        contents += `<li class="btnChangeWallTexture"  data-itemid=${i} >`;
        contents += `<button id="changeWallTexture${String(i)}">`;
        contents += '<div class="imbBox">';
        contents += `<img src="${imgPath}" width="96" height="96"/>`;
        contents += '</div>';
        contents += `<p><span class="jp">${alt.name}</span><span class="en">${alt.name_en}</span></p>`;
        contents += '</li>';
      }
    }
    contents += '</ul>';
    contents += '</div>';
    contents += '</div>';

    const footer = '';

    this.createDialog(id, title, contents, footer);

    this.viewObj.querySelectorAll('button').forEach((element) => {
      element.addEventListener('click', this.close);
    });

    // 家具変更ダイアログの処理を参考に残す
    // 選択中のアイテムを更新
    // this.updateCurrent(this.target);
    document.querySelectorAll('.btnChangeWallTexture').forEach((elem) => {
      elem.addEventListener('click', (e) => {
        // const itemid = parseInt((<HTMLElement> e.currentTarget).getAttribute('data-itemid'), 10);
        // new ChangeItem().changeItem(this.index, itemid);
        // // marietta.view3d.webcad.View3dGlobal.shared.changeItem(this.index, itemid);
        // // 変更フラグを立てる
        // webcad.WebCADGlobal.webcad2Dmanager.isChanged = true;
      })
    });
  }

  // 家具変更ダイアログの処理を参考に残す
  /**
   * 選択中のアイテムを更新
   */
  /* updateCurrent(_target) {
    const index = _target.currentSelection;
    if (index !== undefined) {
      (this.viewObj).querySelectorAll('.changeWallTextureMenu').forEach((elem) => {
        (elem.querySelectorAll('li')[index].querySelector('button').classList.add('is-active'));
      });
    }
  } */
}
